import { render, staticRenderFns } from "./edit-project-legder.vue?vue&type=template&id=6ebafbcf&scoped=true"
import script from "./edit-project-legder.vue?vue&type=script&lang=ts"
export * from "./edit-project-legder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebafbcf",
  null
  
)

export default component.exports